import { useUser } from '~/api/user';
import { Redirect } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

import { CreateEditJobPostForm } from './CreateEditJobPostForm';

export const CreateJobPost = () => {
  const { data: user } = useUser();

  if (!user.communityProfile.enabled) {
    return <Redirect to={routes.jobPosts} />;
  }

  return <CreateEditJobPostForm jobPost={null} mode="create" />;
};
